export const roReportTranslations = {
  'report.modal.title': 'Generarea raportului de campanie',
  'report.modal.error.title': 'Eroare',
  'report.modal.error.text': 'A apărut o eroare în timpul generării raportului',
  'report.modal.selector.text':
    'Generarea unui raport de campanie poate dura câteva minute. Descărcarea va începe automat odată ce operațiunea este finalizată.',
  'report.modal.error.button': 'Închide',
  'report.modal.button': 'Descărcare',
};
